import React, { useEffect } from "react";
import { RenderForm } from "../../utils/formUtils";
import useForm from "../../hooks/useForm";
import { usePaymentMethodsForm } from "../../hooks/payment-methods/usePaymentMethodsForm";
import { FormWrapper } from "../tickets/ClientTicketForm";
import { Stack } from "@mui/material";
import { FormButton } from "../../components/buttons/FormButton";
import { AutofillForm } from "../../utils/helpers";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { PAYMENT_METHODS_REF } from "../../constants/api";

export const PaymentMethodsForm = ({ setOpen }) => {
  const { form, onChange, updateFormValues, setForm } = useForm();
  const { formFields: fields } = usePaymentMethodsForm();
  const { loading, getDocData, data, updateData } = useFirebase();

  AutofillForm(data, setForm);

  useEffect(() => {
    getDocData(PAYMENT_METHODS_REF);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();

    const docRef = form?.docRef;
    if (docRef)
      updateData(docRef, { message: form?.message }).then(() => setOpen(false));
  };

  return (
    <form onSubmit={onSubmit}>
      <FormWrapper>
        <Stack spacing={3}>
          <RenderForm {...{ form, onChange, fields, updateFormValues }} />
          <FormButton loading={loading}>Submit</FormButton>
        </Stack>
      </FormWrapper>
    </form>
  );
};
